import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,

  client: {
    name: 'schueco',
    supportedLanguages: ['de', 'da', 'en', 'es', 'fr', 'it', 'ja', 'nl', 'pl', 'ru', 'zh'],
    downloadCollectionCategoryIds: [201486, 201488, 201487],
  },

  apiData: {
    apiID: 'planonePim',
    apiURL: 'https://backend.docucenter.schueco.com/',
    assetURL: 'https://cdn.docu-center.planone.company/',
  },

  keycloakConfig: {
    url: 'https://login-ext.schueco.com/auth',
    realm: 'schueco',
    clientId: 'schueco-docu',
  },

  basicAuth: 'ZG9jdWNlbnRlcjpkb2N1Y2VudGVy',

  redirect: {
    targetHost: 'docucenter.schueco.com',
  },

  unleash: {
    url: 'https://unleash-proxy.docucenter.schueco.dev/proxy',
    clientKey: '600pCFDQxpht8dDE',
    appName: 'default',
    environment: 'schueco-production',
  },

  mapp: {
    trackDomain: 'schueco01.webtrekk.net',
    trackId: '243314783131833',
  },

  trustcommander: {
    siteId: '6062',
    fileNames: {
      de: 'privacy_v2_51.js',
      en: 'privacy_v2_52.js',
    },
  },
};
